import React from "react";
import { Image } from '../../../ui';
import styles from './production.module.scss';
import PropTypes from 'prop-types';
const ItemDeatilsSection = ({ detail , comment}) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.left}>
                <div className={styles.image}>
                    {detail.product.main_photos && <Image src={`https://leoprinting.nl/files/photos/${detail.product.main_photos[0]}`}
                    />}
                </div>
                <p className={styles.imageTag}>Image is for illustration.Real product may vary</p>
            </div>
            <div className={styles.right}>

                <h3>Specifications :</h3>
                <div className={styles.specifications}>
                    {detail.specification.map(({ name, value }) => (
                        <React.Fragment key={name}>
                            <div className={styles.name}>{name}</div>
                            <div className={styles.value}>{value}</div>
                        </React.Fragment>
                    ))}
                    {detail.item_hidden_specification.map(({ name, value }) => (
                        <React.Fragment key={name}>
                            <div className={styles.name}>{name}</div>
                            <div className={styles.value}>{value}</div>
                        </React.Fragment>
                    ))}
                </div>
                {comment && <i><b>Comment from Leoprinting :</b> {comment}</i>}
            </div>
        </div>
    );
}

ItemDeatilsSection.propTypes = {
    detail: PropTypes.object.isRequired,
    comment: PropTypes.string
}
export default ItemDeatilsSection